const PHOTO_TYPES = ['mainPhoto', 'horizontalPhoto', 'photos']
export default PHOTO_TYPES